/* @ngInject */
function ManageUserStatusDialogController ($scope, $rootScope, $translate, AdminService, ToastService) {
  $scope.loading = false
  $scope.disabledButton = true
  $scope.userHasMoreEnvironments = false
  $scope.warningMsg = true
  $scope.dialogTitle = $translate.instant('beware')

  const THIS_COMPANY = 'thisCompany'
  const ALL_COMPANIES = 'allCompanies'

  $scope.selectedOption = {}
  $scope.companies = []

  const api = {
    _getRadioOptions,
    _inactivateUser,
    _inactivateUserMultipleEnvironments,
    _activateUser,
    _activateUserMultipleEnvironments,
    _getDialogTitle,
    _getUserCompanies,
    _showRadioButtons
  }
  this.getApi = () => api

  activate()

  function activate () {
    $scope.radioOptions = api._getRadioOptions($scope.data.type)
    api._getUserCompanies($scope.data.user.id)
  }

  $scope.closeDialog = (isSuccess, returnData) => {
    $scope.close(isSuccess, returnData)
  }

  $scope.radioChange = event => {
    if (event.detail.name && event.detail.value) {
      $scope.selectedOption = event.detail.value
      $scope.disabledButton = false
    }
  }

  function _getUserCompanies (userId) {
    if ($scope.data.type === 'activate') {
      AdminService.getActiveAndInactiveUserCompanies(userId).then((res) => { $scope.companies = res })
    } else if ($scope.data.type === 'inactivate') {
      $scope.companies = AdminService.getUserCompanies(userId).then((res) => { $scope.companies = res.companies })
    }
  }

  $scope.onApply = () => {
    $scope.loading = true

    if ($scope.companies && $scope.companies.length === 1) {
      if ($scope.data.type === 'activate') {
        api._activateUser($scope.data.user.id)
      } else if ($scope.data.type === 'inactivate') {
        api._inactivateUser($scope.data.user.id)
      }
    } else {
      api._showRadioButtons()
    }
  }

  function _inactivateUser (userId) {
    const payload = {
      active: false,
      allCompanies: true,
      newCompany: null
    }

    AdminService.updateUserStatus(userId, payload)
      .then(() => {
        $scope.closeDialog(true)
      })
      .catch((error) => {
        $scope.closeDialog(false, error)
      })
  }

  function _activateUser (userId) {
    const payload = {
      active: true,
      allCompanies: true,
      newCompany: null
    }

    AdminService.updateUserStatus(userId, payload)
      .then(() => {
        $scope.closeDialog(true)
      })
      .catch((error) => {
        if (error.data.code === 'LIMIT_ACTIVE_USERS_REACHED') {
          ToastService.showErrorToast($translate.instant('manageUserStatus.verifyCompanyLicenses'))
        }

        $scope.closeDialog(false, error)
      })
  }

  function _showRadioButtons () {
    $scope.userHasMoreEnvironments = true
    $scope.warningMsg = false
    $scope.loading = false
    $scope.dialogTitle = api._getDialogTitle($scope.data.type)
  }

  $scope.onApplyMultipleEnviroments = () => {
    $scope.loading = true

    if ($scope.data.type === 'activate') {
      api._activateUserMultipleEnvironments($scope.data.user.id)
    } else if ($scope.data.type === 'inactivate') {
      api._inactivateUserMultipleEnvironments($scope.data.user.id)
    }
  }

  function _activateUserMultipleEnvironments (userId) {
    const payload = {
      active: true,
      allCompanies: $scope.selectedOption === 'allCompanies',
      newCompany: null
    }

    AdminService.updateUserStatus(userId, payload)
      .then(() => {
        $scope.closeDialog(true)
      })
      .catch((error) => {
        $scope.closeDialog(false, error)
      })
  }

  function _inactivateUserMultipleEnvironments (userId) {
    const environments = $scope.companies.reduce((array, company) => {
      if (company.customerCompanyId !== $rootScope.oUser.customerCompanyId) {
        const value = {
          value: company.customerCompanyId,
          label: company.name
        }

        array.push(value)
      }

      return array
    }, [])

    const payload = {
      active: false,
      allCompanies: $scope.selectedOption === 'allCompanies',
      newCompany: environments.customerCompanyId !== '' ? environments.customerCompanyId : null
    }

    AdminService.updateUserStatus(userId, payload)
      .then(() => {
        $scope.closeDialog(true)
      })
      .catch((error) => {
        $scope.closeDialog(false, error)
      })
  }

  function _getRadioOptions (type) {
    const options = {
      activate: [
        {
          label: $translate.instant('activateUserAllCompanies'),
          value: ALL_COMPANIES
        },
        {
          label: $translate.instant('activateUserHere'),
          value: THIS_COMPANY
        }
      ],
      inactivate: [
        {
          label: $translate.instant('inactivateUserAllCompanies'),
          value: ALL_COMPANIES
        },
        {
          label: $translate.instant('inactivateUserHere'),
          value: THIS_COMPANY
        }
      ]
    }

    return options[type]
  }

  function _getDialogTitle (type) {
    const options = {
      activate: $translate.instant('activateUser'),
      inactivate: $translate.instant('inactivateUser')
    }

    return options[type]
  }
}

export { ManageUserStatusDialogController }
